export default "__VITE_ASSET__kBtE228C__"